import React from 'react';
import { useDispatch } from 'react-redux';

import { App } from '../components/App';
import { authoriseAccessRequest } from '../ducks';

interface Props {
  children: React.ReactNode;
  hideHeader?: boolean;
}

const OptionalAuthenticationPathComponent = ({ children, hideHeader }: Props) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(authoriseAccessRequest());
  }, [dispatch]);

  return <App hideHeader={hideHeader}>{children}</App>;
};

export const OptionalAuthenticationPath = React.memo(OptionalAuthenticationPathComponent);
